import React from "react";
import { Col, Row } from "react-bootstrap";


const ImmoComponent = (props) => {

    return (
        <Row className="mt-5 justify-content-center">
            <Col xs="12" xl="8" className="text-center">
                <img src={(props.logo && props.logo !== "False") || props.logo !== null?
                    "data:image/jpg;base64,"+props.logo : null} className="img-fluid" alt=""/>
                <h4 hidden={props.logo === null? false:true}>{props.name}</h4>
            </Col>
        </Row>
    )
} 

export default ImmoComponent;